import { render } from "./PharmacyInventory.vue?vue&type=template&id=7d315204&scoped=true"
import script from "./PharmacyInventory.vue?vue&type=script&lang=js"
export * from "./PharmacyInventory.vue?vue&type=script&lang=js"

import "./PharmacyInventory.vue?vue&type=style&index=0&id=7d315204&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d315204"]])

export default __exports__